import { differenceInCalendarDays } from 'date-fns';
import normalizeDate from './normalize-date';

export default function isProlongationNeeded(expireAt: string | Date, interval = 4): boolean {
  const date = normalizeDate(expireAt);
  return differenceInCalendarDays(date, new Date()) <= interval;
}
